<template>
    <component
        v-bind="$attrs"
        v-bind:is="buttonLink ? 'pc-button-link' : 'pc-button'"
        v-bind:primary="primary"
        v-bind:link="buttonLink ? null : link"
        v-bind:warning="warning"
        v-bind:success="success"
        v-bind:small="small"
        v-bind:outline="outline">
        <pc-bs-icon
            v-if="icon"
            class="me-1"
            v-bind:name="icon" />
        <slot />
    </component>
</template>
<script>
    export default {
        props: {
            icon: { type: String, required: false, default: null },
            buttonLink: { type: Boolean, required: false, default: false },

            // props that get forwarded to inner component - they need to be declared in the stateful case
            primary: { type: Boolean, required: false, default: false },
            link: { type: Boolean, required: false, default: false },
            warning: { type: Boolean, required: false, default: false },
            success: { type: Boolean, required: false, default: false },
            small: { type: Boolean, required: false, default: false },
            outline: { type: Boolean, required: false, default: false }
        }
    };
</script>
